import { useEffect, useState } from 'react';
import { keyLabel } from '../prefs';

/** Button that captures the next key press (KeyboardEvent.code) for push-to-talk. */
export function KeyCapture({ value, onChange }: { value: string; onChange: (code: string) => void }) {
  const [capturing, setCapturing] = useState(false);
  useEffect(() => {
    if (!capturing) return;
    document.body.dataset.capturingKey = 'true';
    const onKey = (e: KeyboardEvent) => {
      e.preventDefault();
      e.stopPropagation();
      if (e.code !== 'Escape') onChange(e.code);
      setCapturing(false);
    };
    window.addEventListener('keydown', onKey, { capture: true });
    return () => {
      delete document.body.dataset.capturingKey;
      window.removeEventListener('keydown', onKey, { capture: true });
    };
  }, [capturing, onChange]);
  return (
    <button type="button" className={`btn btn-small key-capture${capturing ? ' is-capturing' : ''}`} onClick={() => setCapturing(true)} data-testid="ptt-key">
      {capturing ? 'Premi un tasto… (Esc annulla)' : <kbd>{keyLabel(value)}</kbd>}
    </button>
  );
}
